import { Display, Text, VStack } from '@bonusly/design-system';
import { useIsBonuslyCompany } from '@bonusly/who-am-i';

import { GranolaConnectCard } from '../../../components/granola/granola-connect-card';

export const RecommendationsPage = () => {
	const isBonuslyCompany = useIsBonuslyCompany();

	if (!isBonuslyCompany) {
		return null;
	}

	return (
		<VStack p={6} spacing={6} align="stretch" maxW="800px">
			<VStack spacing={1} align="flex-start">
				<Display as="h1" size="sm" fontWeight="bold" color="text.default">
					Recognition Recommends
				</Display>
				<Text fontSize="sm" color="text.softer">
					Connect a transcript source to surface recognition-worthy moments.
				</Text>
			</VStack>

			<GranolaConnectCard />
		</VStack>
	);
};
